import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TableHeaderCont,
  NameColumn,
  PhoneColumn,
  LanguageColumn,
  FilterIcon,
  FilteredLanguagesNumber,
  TeamColumn,
  LeaderColumn,
  LegendCont,
  RoleColumn,
  StatusColumn,
} from './ParticipantTableHeader.styles';
import { languagesArr } from '../../../constans/forms';
import { getLangCode } from '../../../helpers/helpers';
import Dropdown from '../../Dropdown/Dropdown';
import ReportResultsLegend from '../../ReportResultsLegend/ReportResultsLegend';

interface IParticipantTableHeader {
  selectedLanguages: string[];
  applyFilters: (filters: Record<string, string | null | undefined>) => void;
  isEffectSurvey: boolean;
}

const ParticipantTableHeader: FC<IParticipantTableHeader> = ({
  selectedLanguages,
  applyFilters,
  isEffectSurvey,
}) => {
  const { t } = useTranslation();
  const supportedLanguages = languagesArr.map(language => language.name);

  const onFilterChange = useCallback(
    (filters: string[]) => {
      applyFilters({
        language: filters.map(filter => getLangCode(filter)).join(),
        pageNo: null,
      });
    },
    [applyFilters]
  );

  return (
    <>
      <TableHeaderCont id="TableHeaderCont">
        <NameColumn>{t('viewSurvey.participants.tableHeader.name')}</NameColumn>

        <PhoneColumn>{t('viewSurvey.participants.tableHeader.phone')}</PhoneColumn>

        <LanguageColumn>
          {t('viewSurvey.participants.tableHeader.language')}
          <Dropdown
            selectedItems={selectedLanguages || []}
            options={supportedLanguages}
            icon={<FilterIcon id="FilterIcon" data-testid="filterIcon" />}
            onSelect={filter => onFilterChange(filter)}
            onDeselect={filter => onFilterChange(filter)}
            style={{ minWidth: 174 }}
          />
          {selectedLanguages.length > 0 && (
            <FilteredLanguagesNumber
              id="FilteredLanguagesNumber"
              data-testid="filteredLanguagesNumber"
            >
              ({selectedLanguages.length})
            </FilteredLanguagesNumber>
          )}
        </LanguageColumn>
        {isEffectSurvey ? (
          <RoleColumn>{t('viewSurvey.participants.tableHeader.role')}</RoleColumn>
        ) : (
          <>
            <TeamColumn id="TeamColumn">{t('viewSurvey.participants.tableHeader.team')}</TeamColumn>
            <LeaderColumn id="Column">
              {t('viewSurvey.participants.tableHeader.leader')}
            </LeaderColumn>
          </>
        )}
        <StatusColumn>{t('viewSurvey.participants.tableHeader.status')}</StatusColumn>
      </TableHeaderCont>
      <LegendCont id="LegendCont">
        <ReportResultsLegend
          variant="simple"
          description={
            isEffectSurvey
              ? t('viewSurvey.participants.tableHeader.effectLegendText')
              : t('viewSurvey.participants.tableHeader.legendText')
          }
          hideExpand={!isEffectSurvey}
        />
      </LegendCont>
    </>
  );
};

export default ParticipantTableHeader;
